import React, { useEffect, useState } from "react";

const KEY = "accessnova_cookie_consent_v1";

export const CookieBanner = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        try {
            const stored = window.localStorage.getItem(KEY);
            if (!stored) setVisible(true);
        } catch (_) {
            setVisible(true);
        }
    }, []);

    const decide = (value) => {
        try { window.localStorage.setItem(KEY, value); } catch (_) {}
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div
            role="region"
            aria-label="Cookie consent"
            className="fixed inset-x-0 bottom-0 z-50 px-4 pb-4"
            data-testid="cookie-banner"
        >
            <div className="mx-auto max-w-4xl rounded-lg bg-white border border-brand-border shadow-cardHover p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center sm:gap-6 gap-4">
                <p className="text-sm text-brand-body flex-1">
                    We use essential cookies to make this site work and analytics cookies to improve it.
                    See our{" "}
                    <a href="/privacy" className="text-brand-teal underline hover:text-brand-tealBright">
                        Privacy Policy
                    </a>.
                </p>
                <div className="flex items-center gap-3">
                    <button
                        onClick={() => decide("rejected")}
                        className="rounded-md border border-brand-navy text-brand-navy hover:bg-brand-soft font-medium px-4 py-2 text-sm transition-colors touch-target"
                        data-testid="cookie-reject-button"
                    >
                        Reject
                    </button>
                    <button
                        onClick={() => decide("accepted")}
                        className="rounded-md bg-brand-navy text-white hover:bg-brand-teal font-semibold px-4 py-2 text-sm transition-colors touch-target"
                        data-testid="cookie-accept-button"
                    >
                        Accept
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieBanner;
